import styles from "./CalenderWall.module.css";

import Footer from "../../Footer/Footer";
import Header from "../../Header/Header";

import DesignBoxNavigationCrumb from "../../Reusables/DesignBoxNavigationCrumb";
import EditScreenHeaderInfoDiv from "../../Reusables/EditScreenHeaderInfoDiv";
import EditScreenItemHeaderDiv from "../../Reusables/EditScreenItemHeaderDiv";

import React from "react";

import { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import save_icon from "../../../assets/images/icons/save_icon.png";
import useAxios from "../../Hooks/useAxios";
import PhotoSelection from "../PhotoSelection/PhotoSelection";

import { createRef } from "react";
import CalenderWallReusable from "./CalenderWall_Reusable";

const CalenderWall = () => {
  const MAX_ITEMS = 50;
  const childRefs = useRef(
    Array(MAX_ITEMS)
      .fill(null)
      .map(() => createRef())
  );

  const [copyDetails, setCopyDetails] = useState([]);
  const [item, setItem] = useState({});
  const { product_id } = useParams();
  const axios = useAxios();
  const navigate = useNavigate();
  const backend_base = process.env.REACT_APP_API_BASE_URL;
  const [saveSuccess, setSaveSuccess] = useState(false);

  const [count, setCount] = useState(0);
  const [showSelectionPopup, setShowSelectionPopup] = useState(false);
  const [imagesLeft, setImagesLeft] = useState(0);
  const [currentImageSelectionIndex, setCurrentPhotoSelectionIndex] =
    useState(-1);
  const [psk, setpsk] = useState(0);
  let [editState, setEditState] = useState([]);
  const [selectedImageSlot, setSelectedImageSlot] = useState(-1);

  console.log(editState, "editStateLatest");

  const imageSelectionPopup = (index, count, selectedSlot = -1) => {
    setShowSelectionPopup(true);
    setImagesLeft(count);
    setCurrentPhotoSelectionIndex(index);
    setpsk(psk + 1);
    setSelectedImageSlot(selectedSlot);
    console.log("EDITSTATE BEFORE");
    console.log(editState);
  };
  const onPhotoSelectionEnd = (photo_url) => {
    setShowSelectionPopup(false);
    console.log("Photo Selection ends");
    console.log(photo_url.length);
    console.log(photo_url);
    const temp = JSON.parse(JSON.stringify(editState));
    console.log("States Before");
    console.log(temp);
    console.log("Images Selected:");
    console.log(photo_url);
    let picIdx = 0;
    if (selectedImageSlot === -1) {
      for (let i = 0; i < 4; i++) {
        for (let j = 0; j < 3; j++) {
          if (picIdx >= photo_url.length) break;
          if (temp[currentImageSelectionIndex].images[i][j].src === "") {
            temp[currentImageSelectionIndex].images[i][j].src =
              photo_url[picIdx++];
          }
        }
      }
    } else {
      for (let i = 0; i < 4; i++) {
        for (let j = 0; j < 3; j++) {
          if (
            temp[currentImageSelectionIndex].images[i][j].id ===
            selectedImageSlot
          ) {
            temp[currentImageSelectionIndex].images[i][j].src =
              photo_url[picIdx++];
          }
        }
      }
    }
    console.log("States After");
    console.log(temp);
    setEditState(temp);
  };

  let tempArr = [];
  for (let i = 0; i < 4; i++) {
    let t = [];
    for (let j = 0; j < 3; j++) {
      t.push({
        id: (3 * i + j).toString(),
        src: "",
      });
    }
    tempArr.push(t);
  }

  let defaultStateSingleProduct = {
    images: tempArr,
    selected: "1月始まり",
    copied: false,
  };

  const completeDesign = (info) => {
    for (let it = 0; it < info.length; it++) {
      if (info[it].option === "") return false;
      console.log("here");
      console.log(info[it].images);
      for (let i = 0; i < 4; i++) {
        for (let j = 0; j < 3; j++) {
          if (info[it].images[i][j].src === "") {
            return false;
          }
        }
      }
    }
    return true;
  };

  const confirmEdits = () => {
    console.log("Confirm Edits. Send to server");
    const tempInfo = [];
    let newEditState = editState;
    for (let i = 0; i < count; i++) {
      tempInfo.push(childRefs.current[i].current.getAllInfo());
      newEditState[i].images = tempInfo[i].images;
      newEditState[i].selected = tempInfo[i].option;
    }
    console.log(tempInfo);
    if (!completeDesign(tempInfo)) {
      alert("Please Upload All Images");
    }

    const tempDetails = [];
    for (let i = 0; i < newEditState.length; i++) {
      tempDetails.push(newEditState[i]);
    }

    console.log(newEditState, "test");

    const data = new FormData();
    data.append("design_details", JSON.stringify(tempDetails));
    data.append("copy_details", JSON.stringify(copyDetails));
    data.append("order_item_id", product_id);
    data.append("action", "CONFIRM");

    axios
      .post(backend_base + "/design/edit", data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        if (res.status === 201 || res.status === 200) {
          console.log("Posted THE EDIT DATA");
          console.log(res.data);
          // navigate("/design-box");
          navigate("/design-box/complete-submission", { state: { title : "年賀状", subtitle : "年賀状制作 20枚", count : count, address : "", item : item } });
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const saveToServer = () => {
    console.log("Send This to server");
    console.log(editState);
    const tempDetails = [];
    for (let i = 0; i < editState.length; i++) {
      tempDetails.push(editState[i]);
    }
    let save_data = {
      design_details: JSON.stringify(tempDetails),
      order_item_id: product_id,
      preview_images: [],
      action: "SAVE",
      copy_details: JSON.stringify(copyDetails),
    };

    axios
      .post(backend_base + "/design/edit", save_data)
      .then((res) => {
        if (res.status === 201 || res.status === 200) {
          console.log("SAVED THE EDIT DATA");
          console.log(res.data);
          setSaveSuccess(true);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };

  useEffect(() => {
    axios
      .get(backend_base + "/order/item/details/" + product_id)
      .then((res) => {
        if (res.status === 201 || res.status === 200) {
          console.log("Success Getting Product With ID");
          console.log(res.data);
          setItem(res.data);
          setCount(res.data.quantity);
          let design = res.data.design;
          let status = design.design_status;
          console.log(design);
          console.log(design.design_status);

          if (status === "SAVED") {
            console.log(JSON.parse(design.design_details));
            setEditState(JSON.parse(design.design_details));
            setCopyDetails(JSON.parse(design.copy_details));
          } else {
            let tempState = [];
            let tempCopyDetails = [];
            for (let i = 0; i < res.data.quantity; i++) {
              const temp = JSON.parse(
                JSON.stringify(defaultStateSingleProduct)
              );
              tempState.push(temp);
              tempCopyDetails.push(i + 1);
            }
            setCopyDetails(tempCopyDetails);
            setEditState(tempState);
          }
        } else {
          console.log("Failed");
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }, []);

  const changeEditState = (index, state) => {
    const temp = JSON.parse(JSON.stringify(editState));
    temp[index] = state;
    setEditState(temp);
  };

  const changeCopyDetails = async (details, index) => {
    console.log("CHANGE COPY DETAILS");
    console.log(index);
    console.log(details);
    const newDetails = JSON.parse(JSON.stringify(copyDetails));
    newDetails[index] = details;
    setCopyDetails(newDetails);
    let tempState = JSON.parse(JSON.stringify(editState[details - 1]));
    tempState.copied = index !== details - 1;
    changeEditState(index, tempState);
  };

  return (
    <>
      {saveSuccess && (
        <div className={styles.SAVE_SUCCESS_MAIN}>
          <div className={styles.save_success_main_div}>
            <div className={styles.save_success_main_text}>
              一時保存しました
            </div>
            <ion-icon
              onClick={() => {
                setSaveSuccess(false);
              }}
              name="close"
            ></ion-icon>
          </div>
        </div>
      )}
      <Header />
      {showSelectionPopup && (
        <PhotoSelection
          skey={psk}
          count={imagesLeft}
          done={onPhotoSelectionEnd}
          allowLessSelects={true}
        />
      )}
      {!showSelectionPopup && (
        <div className={styles.wooden_square_edit_screen_main_div}>
          {count > 0 && (
            <div onClick={saveToServer} className={styles.save_box_main}>
              <img
                src={save_icon}
                className={styles.save_icon_image}
                alt="save"
              />
            </div>
          )}
          <DesignBoxNavigationCrumb active={3} />
          <EditScreenItemHeaderDiv
            title={"壁掛けカレンダー"}
            subtitle={""}
            count={count}
            address={"会員様住所"}
            item={item}
          />
          <EditScreenHeaderInfoDiv
            lines={[
              "始まり月を決定し、12枚写真を選択してください。",
              "入稿後、納品まで約1ヶ月の制作期間を頂戴いたします。",
            ]}
          />

          <div className={styles.title_hr}></div>

          <div className={styles.reusable_main_div}>
            {[...Array(count)].map((_, index) => {
              console.log("Should execute once!");
              const childRef = childRefs.current[index];
              console.log(childRef);
              return (
                <CalenderWallReusable
                  key={index}
                  ref={childRef}
                  index={index}
                  totalItems={count}
                  state={editState[index]}
                  image_selection_popup={imageSelectionPopup}
                  //new stuff
                  changeCopyDetails={changeCopyDetails}
                  selectedCopyDetails={copyDetails[index]}
                  currentPageNumber={index + 1}
                  totalPageNumber={count}
                />
              );
            })}
          </div>
          {count > 0 && (
            <div className={styles.confirm_edits}>
              <div className={styles.confirm_header}>
                上記の内容でデザイン決定しますか？
              </div>
              <div className={styles.confirm_button_section}>
                <button
                  onClick={() => {
                    navigate("/design-box");
                  }}
                  className={styles.confirm_button_no}
                >
                  編集へ戻る
                </button>
                <button
                  onClick={() => {
                    confirmEdits();
                  }}
                  className={styles.confirm_button_yes}
                >
                  はい
                </button>
              </div>
            </div>
          )}
        </div>
      )}

      <Footer />
    </>
  );
};

export default CalenderWall;
